import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaRecibosLista', {
    template: template,
    controller: NominasNominaRecibosListaComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      onGenerar: '&',
    },
  })

function NominasNominaRecibosListaComponent(NominasNominaRecibos) {
  let $ctrl = this
  $ctrl.generar = generar
  $ctrl.seleccionarMultiple = seleccionarMultiple
  $ctrl.totalizar = totalizar
  $ctrl.$onInit = $onInit

  function $onInit() {
    $ctrl.enviarEmail = false
    $ctrl.data = undefined
    $ctrl.seleccionados = []
    $ctrl.todos = false
    $ctrl.promise = NominasNominaRecibos.get($ctrl.idNomina)
      .then(function (data) {
        $ctrl.data = data
      })
  }

  function generar() {
    let data = angular.copy($ctrl.data)
      .filter(function (item) {
        return item.$$selected
      })
      .map(function (item) {
        delete item.$$selected
        item.enviarEmail = $ctrl.enviarEmail === true && item.Email !== null
        return item
      })

    $ctrl.onGenerar({data: data})
  }

  function seleccionarMultiple(seleccionado) {
    $ctrl.data.map(function (item) {
      item.$$selected = seleccionado
      return item
    })
    $ctrl.totalizar()
  }

  function totalizar() {
    $ctrl.seleccionados = $ctrl.data.filter(function (item) {
      return item.$$selected
    })

    $ctrl.todos = $ctrl.seleccionados.length === $ctrl.data.length
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/recibos/lista/component.js